<div>
  <a
    routerLink="/{{ language }}"
    aria-label="MyAstuce : revenir à la page d’accueil"
    (click)="onSidenavClose()"
  >
    <img  
      aria-label="MyAstuce : revenir à la page d’accueil"
      id="app-logo"
      src="assets/site/new-logo-myastuce.png"
      alt="Logo My astuce"
      style="height: 36px; width: 100px"
    />
  </a>
</div>

<nav
  fxHide.sm
  fxHide.xs
  aria-hidden="false"
  aria-label="Menu principal"
  id="block-nav-main-menu"
>
  <ul fxLayout class="navigation-items">
    <li>
      <button
        type="button"
        mat-button
        id="btn-se-deplacer"
        [attr.aria-expanded]="currentMenuPanel === 'panelSeDeplacer' ? 'true' : 'false'"
        [matMenuTriggerFor]="panelSeDeplacer.menu"
        (menuOpened)="menuOpened('panelSeDeplacer')"
        (menuClosed)="menuClosed('panelSeDeplacer')"
        aria-label="Se déplacer"
        class="nav-link px-2 link-dark"
        [ngClass]="{
          cssCurrentPanelOpened: currentMenuPanel === 'panelSeDeplacer'
        }"
      >
        {{ "menu.seDeplacer" | translate }}
      </button>
      <app-menu-panel
        #panelSeDeplacer
        [items]="items['SE-DEPLACER']"
        [ariaLabelledBy]="'btn-se-deplacer'"
      ></app-menu-panel>
    </li>
    <li>
      <button
        type="button"
        mat-button
        id="btn-s-informer"
        [attr.aria-expanded]="currentMenuPanel === 'panelSInformer' ? 'true' : 'false'"
        class="nav-link px-2 link-dark"
        (menuOpened)="menuOpened('panelSInformer')"
        (menuClosed)="menuClosed('panelSInformer')"
        [ngClass]="{
          cssCurrentPanelOpened: currentMenuPanel === 'panelSInformer'
        }"
        [matMenuTriggerFor]="panelSInformer.menu"
        aria-label="S'informer"
      >
        {{ "menu.sInformer" | translate }}
      </button>
      <app-menu-panel
        #panelSInformer
        [items]="items['S-INFORMER']"
        [ariaLabelledBy]="'btn-s-informer'"
      ></app-menu-panel>
    </li>
    <li>
      <button
        type="button"
        mat-button
        id="btn-acheter"
        [attr.aria-expanded]="currentMenuPanel === 'panelAcheter' ? 'true' : 'false'"
        (menuOpened)="menuOpened('panelAcheter')"
        (menuClosed)="menuClosed('panelAcheter')"
        [ngClass]="{
          cssCurrentPanelOpened: currentMenuPanel === 'panelAcheter'
        }"
        [matMenuTriggerFor]="panelAcheter.menu"
        class="nav-link px-2 link-dark"
        aria-label="Acheter"
      >
        {{ "menu.acheter" | translate }}
      </button>
      <app-menu-panel 
        #panelAcheter 
        [items]="items['ACHETER']"
        [ariaLabelledBy]="'btn-acheter'"
      ></app-menu-panel>
    </li>
  </ul>
</nav>

<app-search-bar fxHide.sm fxHide.xs></app-search-bar>

<div style="display: flex; align-items: center" fxHide.sm fxHide.xs>
  <button
    type="button"
    id="btn-langue"
    [attr.aria-label]="'Langue du site : ' + (language === 'fr' ? 'français' : 'english')"
    [attr.aria-expanded]="currentMenuPanel === 'panelLangue' ? 'true' : 'false'"
    mat-button
    (menuOpened)="menuOpened('panelLangue')"
    (menuClosed)="menuClosed('panelLangue')"
    [ngClass]="{
      cssCurrentPanelOpened: currentMenuPanel === 'panelLangue'
    }"
    [matMenuTriggerFor]="panelLangue"
    class="nav-link language-select"
  >
    <img
      *ngIf="language === 'fr'"
      class="img-langue"
      src="../../../assets/site/fr.svg"
      alt="drapeau français"
      aria-hidden="true"
    />
    <img
      *ngIf="language === 'en'"
      class="img-langue"
      src="../../../assets/site/en.svg"
      alt="drapeau anglais"
      aria-hidden="true"
    />
    <span class="language-text">
      {{ language | uppercase }}
    </span>
  </button>

  <mat-menu #panelLangue="matMenu" [attr.aria-labelledby]="'btn-langue'">
    <button
      type="button"
      aria-label="Cliquez pour changer la langue du site en Français"
      mat-menu-item
      (click)="switchLocale('fr')"
    >
      <img
        alt="drapeau français"
        class="img-langue"
        src="../../../assets/site/fr.svg"
        alt="fr"
      />
      <span translate>menu.francais</span>
    </button>
    <!--Commenter ce code pour desactiver la langue English-->
    <button
      type="button"
      aria-label="Cliquez pour changer la langue du site en Anglais"
      mat-menu-item
      (click)="switchLocale('en')"
    >
      <img
        alt="drapeau anglais"
        class="img-langue"
        src="../../../assets/site/en.svg"
        alt="en"
      />
      <span translate>menu.anglais</span>
    </button>
  </mat-menu>

  <button
    aria-label="Affichage"
    type="button"
    aria-haspopup="menu"
    [attr.aria-expanded]="currentMenuPanel === 'panelDisplay' ? 'true' : 'false'"
    class="nav-link px-2 link-dark no-arrow button dropdown-button display-buton"
    id="btn-display"
    [matMenuTriggerFor]="display"
    (menuOpened)="menuOpened('panelDisplay')"
    (menuClosed)="menuClosed('panelDisplay')"
  >
    <div class="display">
      <span>
        <svg width="22" height="18">
          <image
            xlink:href="../../../assets/site/logo-display.svg"
            width="22"
            height="18"
          />
        </svg>
      </span>
      <span class="display-text"
        >{{ "raccourcis.affichage" | translate }}
      </span>
    </div>
    <div class="display-arrow">
      <img src="../../../assets/site/arrow-down.svg" alt="" aria-hidden="true" />
    </div>
  </button>

  <mat-menu
    mat-button
    #display="matMenu"
    [attr.aria-labelledby]="'btn-display'"
    class="accesibility-display"
    role="menu"
  >
    <div
      mat-menu-item
      class="display-item non-clickable"
      role="menuitemcheckbox"
      [attr.aria-checked]="isMapEnabled ? 'true' : 'false'"
      (keydown.space)="toggleMapWithSpace($event)"
    >
      <input
        aria-label="Affichage des cartes"
        type="checkbox"
        id="switch"
        aria-labelledby="display-content-switch"
        (change)="showMap($event)"
        (keydown.space)="toggleMapWithSpace($event)"
        [checked]="isMapEnabled"
      /><label for="switch"></label>
      <span id="display-content-switch" class="display-content">{{
        "configurationUser.afficherLesCartes" | translate
      }}</span>
    </div>
    <div
      mat-menu-item
      class="display-item non-clickable"
      role="menuitemcheckbox"
      [attr.aria-checked]="isRefreshEnabled ? 'true' : 'false'"
      (keydown.space)="toggleRefreshWithSpace($event)"
    >
      <input
        aria-label="Raffraichissement des horaires"
        type="checkbox"
        id="switchHourly"
        aria-labelledby="display-content-hourly"
        (change)="refreshAuto($event)"
        (keydown.space)="toggleRefreshWithSpace($event)"
        [checked]="isRefreshEnabled"
      /><label for="switchHourly"></label>
      <span id="display-content-hourly" class="display-content">{{
        "configurationUser.rafraichissementAutoHoraires" | translate
      }}</span>
    </div>
  </mat-menu>
  
 <ctw-member-button
    role="button"
    aria-label="Accéder à mon compte"
    (raisedEvent)="raisedEvent($event)"
    >
  </ctw-member-button>
</div>
